import { defineComponent, computed } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
var _sfc_main = defineComponent({
  name: "FormItemMessage",
  props: {
    error: String,
    isHelp: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const prefixCls = getPrefixCls("form-item-message");
    const cls = computed(() => [prefixCls, {
      [`${prefixCls}-help`]: props.isHelp
    }]);
    return {
      prefixCls,
      cls
    };
  }
});
export { _sfc_main as default };
